import React from 'react';
import { ToastContainer } from "react-toastify";

const PublicLayout = ({ children }) => {
    return (
        <section className="vh-100 public-layout">
            
            
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col col-xl-4">
                        <div className="card container-card" >
                            <div className="row g-0">
                                <div className="d-flex align-items-center">
                                    <div className="card-body p-4 p-lg-5">                                                                                
                                        {children}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PublicLayout;